import { Overlay } from '../overlay';
import { FullScreenButton } from '../components/overlay-fullscreen-mode';
import { SphereItemType } from 'shared/interfaces/planogram';
import { generateThumbnailUrl } from 'shared/utils/url';
export class ImageOverlay {
    constructor(wrapper, options, item, closeCallback) {
        var _a, _b, _c, _d;
        this.wrapper = wrapper;
        this.closeCallback = closeCallback;
        const productData = item.type === SphereItemType.Product ? item.data : undefined;
        const imageData = item.type === SphereItemType.Image ? item.data : undefined;
        const imageUrl = generateThumbnailUrl((_a = imageData.thumbnails) !== null && _a !== void 0 ? _a : productData.picture.thumbnails);
        const container = document.createElement('div');
        container.classList.add('app-image-overlay-container');
        container.setAttribute('aria-live', 'polite');
        const closeButton = document.createElement('div');
        closeButton.classList.add('overlay-button', 'overlay-button-close');
        closeButton.setAttribute('role', 'button');
        closeButton.setAttribute('tabIndex', '0');
        closeButton.appendChild(document.createElement('span'));
        container.appendChild(closeButton);
        const imageWrapper = document.createElement('div');
        const image = document.createElement('img');
        imageWrapper.classList.add('image-wrapper');
        image.setAttribute('aria-label', (_c = (_b = imageData === null || imageData === void 0 ? void 0 : imageData.accessibility) === null || _b === void 0 ? void 0 : _b.description) !== null && _c !== void 0 ? _c : '');
        image.setAttribute('src', imageUrl);
        imageWrapper.appendChild(image);
        container.appendChild(imageWrapper);
        const seoTitle = (_d = imageData === null || imageData === void 0 ? void 0 : imageData.accessibility) === null || _d === void 0 ? void 0 : _d.title;
        if ((options === null || options === void 0 ? void 0 : options.title) && seoTitle !== undefined) {
            container.classList.add('with-title');
            Overlay.showSeoTitle(imageWrapper, seoTitle);
        }
        if (options === null || options === void 0 ? void 0 : options.fullscreen) {
            const fullscreenContainer = document.createElement('div');
            fullscreenContainer.classList.add('image-fullscreen-container');
            imageWrapper.appendChild(fullscreenContainer);
            this.fullscreenButton = new FullScreenButton(fullscreenContainer);
        }
        const backdrop = document.createElement('div');
        backdrop.classList.add('app-overlay-backdrop');
        this.wrapper.replaceChildren(container, backdrop);
    }
    closeOverlay(e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.closeCallback) {
            this.closeCallback();
        }
        else {
            console.error('"Close" function is not set up');
        }
    }
    handleClick(e) {
        return e.target.tagName !== 'IMG';
    }
}
